/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { StorageModule } from "@vlinder-web/storage-module-react";
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import config from "../config/brand.config.json";
import { GET_BANDS } from "../graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
const is = require("is_js");

const SERVICE_NAME = "AppNavigatorService.BrandService";
const log: any = LoggerModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IBrandMethods extends IPluginMethodMap {
  getBrandProfile(args: any): Promise<any>;
}

export class BrandService implements IAgentPlugin {
  readonly methods: IBrandMethods;

  constructor() {
    this.methods = {
      getBrandProfile: this.getBrandProfile.bind(this),
    };
  }

  async getBrandProfile() {
    const storageSrv = StorageModule.getInstance();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const localStorage = storageSrv?.get("currencyExchangeLocal", "local");
        let band;
        if (is.existy(localStorage?.band)) {
          band = localStorage?.band
        }
        console.log(band)
        if (band) {
          const res = await client.query({
            query: GET_BANDS,
            variables: {
              filter: {
                bandName: band
              }
            },
            fetchPolicy: "network-only",
          });
          if (res?.data?.getBand) {
            storageSrv.set(
              "theme",
              res?.data?.getBand,
              "local"
            );
            storageSrv.set(
              "theme",
              res?.data?.getBand,
              "session"
            );
            return {
              ...(config || {}),
              ...res?.data?.getBand,
            };
          }
        }
        return {
          ...(config || {}),
        }
      }
    } catch (err: any) {

    }
  }
}
